var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Tooltip',{attrs:{"content":_vm.$t(_vm.auth0.labelKey)}},[_c('Tag',{staticClass:"p-1",attrs:{"type":"border","color":_vm.auth0.color}},[_c('img',{staticClass:"h-4",attrs:{"src":require("@/assets/auth0.png"),"alt":"Logo Auth0"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }